var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('mpx-view',{staticClass:"checkbox",class:(_vm.isChecked && 'checked'),on:{"tap":function($event){$event.stopPropagation();return _vm.toggleCheck.apply(null, arguments)}}},[_c('div',{staticClass:"checkbox-inner",class:(_vm.isChecked && 'checked')})])
}
var staticRenderFns = []

export { render, staticRenderFns }